import React from "react";
import styled from "styled-components/macro";
import { MdSearch } from "react-icons/md";
import { colors } from "theme/Theme";
import { device, toRem } from "theme/Breakpoints";
import { bgFade } from "theme/Animations";
import { useSearch } from "hooks/useSearch";
import SearchResult from "./SearchResult";
import Preloader from "components/Preloader/Preloader";

const SearchBar: React.FC = () => {
  const { searchTerm, result, isSearching, viewAll, onSearch } = useSearch();
  return (
    <SearchBarContainenr>
      <SearchButton>
        <MdSearch color="white" size="1.5em" />
      </SearchButton>
      <TextInput
        placeholder="Търсете по модел на климатик"
        value={searchTerm}
        onChange={onSearch}
      ></TextInput>
      <DropdownDataContainer className={searchTerm !== "" ? "show" : ""}>
        <DataWrapper>
          {isSearching ? (
            <Preloader />
          ) : (
            <SearchResult result={result} viewAll={viewAll} />
          )}
        </DataWrapper>
      </DropdownDataContainer>
    </SearchBarContainenr>
  );
};

const SearchBarContainenr = styled.div`
  position: relative;
  display: inline-flex;
  /* margin: 0 20px 0 20px; */
  @media only screen and (${device.laptop}) {
    width: ${toRem(320)};
    height: ${toRem(40)};
  }
  @media only screen and (${device.laptopL}) {
    width: ${toRem(490)};
  }
`;

const TextInput = styled.input`
  padding: 0 5px 0 5px;
  z-index: 5;
  background-color: white;
  margin: 0 2px;
  border-style: solid;
  border-width: 1.5px;
  border-color: ${colors.light_blue};
  width: 100%;
`;

const SearchButton = styled.div`
  z-index: 5;
  background: rgb(0, 152, 255);
  background: linear-gradient(
    90deg,
    rgba(0, 152, 255, 1) 0%,
    rgba(0, 76, 128, 1) 100%
  );
  display: inline-flex;
  justify-content: center;
  align-items: center;
  @media only screen and (${device.laptop}) {
    min-width: ${toRem(40)};
    height: ${toRem(40)};
  }
`;

export const DropdownDataContainer = styled.div`
  z-index: 4;
  position: absolute;
  right: 0;
  display: none;

  &.show {
    animation: ${bgFade} 0.3s ease-out;
    display: block;
  }
  @media only screen and (${device.laptop}) {
    width: ${toRem(320)};
  }
  @media only screen and (${device.laptopL}) {
    width: ${toRem(490)};
  }
`;

export const DataWrapper = styled.div`
  padding: 5px;
  max-height: 400px;
  overflow-y: auto;
  margin-top: 52px;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);

  &::before {
    content: "";
    border-style: solid;
    border-width: 10px 10px 10px 20px;
    border-color: transparent #fff transparent transparent;
    position: absolute;
    transform: rotate(90deg);
    top: 30px;
    left: 5px;
  }
`;

const Element = styled.div`
  height: 300px;
`;

export default SearchBar;
